import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getAddMode = (state: RootState) => state.pages.editor.canvas.isAddRulerEnabled;

const isAddRulerEnabled = createSelector([getAddMode], (enabled) => enabled);

export default isAddRulerEnabled;
